<script lang="ts">
	import PopupSelect from './PopupSelect.svelte';
	import type { SelectOption } from '$lib/shared/lib/popup-types';

	interface Props {
		options?: SelectOption[];
		selected?: string;
		placeholder?: string;
		searchable?: boolean;
		buttonClass?: string;
		maxHeight?: string;
		popupId?: string;
		showAvatars?: boolean;
		onchange?: (detail: { value: string; option: SelectOption }) => void;
	}

	let {
		options = [],
		selected = $bindable(''),
		placeholder = 'Select option',
		searchable = true,
		buttonClass = 'btn w-full justify-between',
		maxHeight = 'max-h-64',
		popupId = `dropdown-select-${Math.random().toString(36).substr(2, 9)}`,
		showAvatars = false,
		onchange
	}: Props = $props();
</script>

<PopupSelect
	{options}
	bind:selected
	{placeholder}
	{searchable}
	{buttonClass}
	{maxHeight}
	{popupId}
	{showAvatars}
	onchange={(detail) => onchange?.(detail)}
/>
